import { useSelector } from 'react-redux';

import { selectPayment, selectStatusCreatePaymentAddress } from 'src/store/slice/payment/state';
import { selectStatusCreateQuote } from 'src/store/slice/quote/state';
import { EPricingMode, EInvoice } from 'src/store/slice/payment/interface';
import { selectStatusGetMarketPrice } from 'src/store/slice/marketPrice/state';

import { ERequestStatus } from 'src/api/enumRequest';
import { useCustomSearchParams } from 'src/hook';
import { useAppContext } from 'src/context/useAppContext';
import { EPaymentStatus } from 'src/type';

const useWidgetHelp = () => {
  const { isDemo } = useCustomSearchParams();
  const { currency } = useAppContext();

  const payment = useSelector(selectPayment);

  const statusCreatePaymentAddress = useSelector(selectStatusCreatePaymentAddress);
  const statusCreateQuote = useSelector(selectStatusCreateQuote);
  const statusGetMarketPrice = useSelector(selectStatusGetMarketPrice);

  const { type, pricing_mode, client_status, currency_id } = payment || {};

  const isDefaultInvoice = type === EInvoice.Invoice;
  const isOpenDepositInvoice = type === EInvoice.OpenDeposit;

  const isConvertOnArrival = pricing_mode === EPricingMode.ConvertOnArrival;
  const isLongLivedQuote = pricing_mode === EPricingMode.LongLivedQuote;

  const isPaymentCompleted = client_status === EPaymentStatus.Completed;
  const isSetedDefaultInvoiceCurrency = currency_id === currency.currency_id;

  const isRequestCreatePaymentAddressSuccess = statusCreatePaymentAddress === ERequestStatus.success;
  const isRequestCreateQuoteSuccess = statusCreateQuote === ERequestStatus.success;
  const isRequestGetMarketPrice = statusGetMarketPrice === ERequestStatus.success;

  const requestPendinOpenDepositInvoice = isRequestCreatePaymentAddressSuccess || isDemo;
  const requestPendingDefaultInvoice = isSetedDefaultInvoiceCurrency
    ? isRequestCreatePaymentAddressSuccess || isDemo
    : ((isRequestGetMarketPrice || isRequestCreateQuoteSuccess) && isRequestCreatePaymentAddressSuccess) || isDemo;

  const isRequesSuccess =
    (isDefaultInvoice && requestPendingDefaultInvoice) || (isOpenDepositInvoice && requestPendinOpenDepositInvoice);

  return {
    isDefaultInvoice,
    isOpenDepositInvoice,

    isConvertOnArrival,
    isLongLivedQuote,

    isPaymentCompleted,
    isSetedDefaultInvoiceCurrency,

    isRequesSuccess,
  };
};

export { useWidgetHelp };
